import React, { useContext } from "react";
import {
  BODY_TYPE_CAR_ARRAY, BODY_TYPE_MOTO_ARRAY,
  BODY_TYPE_TRUCK_ARRAY, CAPACITY_ARRAY, COURSE_ARRAY,
  FUEL_ARRAY, FUEL_MOTO_ARRAY,
  GEAR_ARRAY, GEAR_MOTO_ARRAY,
  INVOICE_ARRAY,
  POWER_ARRAY, STATES_ARRAY, YEAR_ARRAY
} from "@motorata/base-ui.data";
import CheckboxesGroup from "@motorata/base-ui.components.atoms.checkboxes-group";
import { RangeSelect } from "@motorata/base-ui.components.atoms.select";
import { FilterContext } from "@/providers/FilterProvider";

const FiltersComponents = ({ onChange }) => {
  const { filters } = useContext(FilterContext)

  let FINAL_BODY_TYPES_ARRY = BODY_TYPE_CAR_ARRAY;

  if (filters.productType === "truck") {
    FINAL_BODY_TYPES_ARRY = BODY_TYPE_TRUCK_ARRAY;
  }

  if (filters.productType === "motorbikes") {
    FINAL_BODY_TYPES_ARRY = BODY_TYPE_MOTO_ARRAY;
  }

  return (
    <>
      <CheckboxesGroup
        name="states"
        label="Stan przedmiotu"
        value={filters.states}
        onChange={onChange}
        options={STATES_ARRAY}
        marginBottom="S"
      />
      <RangeSelect
        name="year"
        value={filters.year}
        label="Rocznik"
        labels={["Od", "Do"]}
        onChange={onChange}
        shrink={[!!filters.year[0], !!filters.year[1]]}
        options={[YEAR_ARRAY, YEAR_ARRAY]}
        marginBottom="S"
      />
      <CheckboxesGroup
        name="bodyType"
        label="Nadwozie"
        value={filters.bodyType}
        onChange={onChange}
        options={FINAL_BODY_TYPES_ARRY}
        marginBottom="S"
      />
      <CheckboxesGroup
        name="gearBox"
        label="Skrzynia biegów"
        value={filters.gearBox}
        onChange={onChange}
        options={filters.productType === "motorbikes" ? GEAR_MOTO_ARRAY : GEAR_ARRAY}
        marginBottom="S"
      />
      <CheckboxesGroup
        name="fuel"
        label="Rodzaj paliwa"
        value={filters.fuel}
        onChange={onChange}
        options={filters.productType === "motorbikes" ? FUEL_MOTO_ARRAY : FUEL_ARRAY}
        marginBottom="S"
      />
      <CheckboxesGroup
        name="invoice"
        label="Rodzaj faktury"
        value={filters.invoice}
        onChange={onChange}
        options={INVOICE_ARRAY}
        marginBottom="S"
      />
      <RangeSelect
        name="course"
        value={filters.course}
        label="Przebieg"
        labels={["Od", "Do"]}
        onChange={onChange}
        shrink={[!!filters.course[0], !!filters.course[1]]}
        options={[COURSE_ARRAY, COURSE_ARRAY]}
        marginBottom="S"
      />
      <RangeSelect
        name="capacity"
        value={filters.capacity}
        label="Pojemność silnika"
        labels={["Od", "Do"]}
        onChange={onChange}
        shrink={[!!filters.capacity[0], !!filters.capacity[1]]}
        options={[CAPACITY_ARRAY, CAPACITY_ARRAY]}
        marginBottom="S"
      />
      <RangeSelect
        name="power"
        value={filters.power}
        label="Moc"
        labels={["Od", "Do"]}
        onChange={onChange}
        shrink={[!!filters.power[0], !!filters.power[1]]}
        options={[POWER_ARRAY, POWER_ARRAY]}
      />
    </>
  );
};

export default FiltersComponents;
